<p-select [options]="options" [(ngModel)]="value" optionValue="value" optionLabel="label"
    class="form-control form-control-sm" placeholder="Select" [disabled]="disableField" [showClear]="true"
    (onChange)="valueChange($event)" appendTo="body">
</p-select>